import { useAppContext } from "../context/AppContext";
import { ButtonsTrans } from "../utils/translations";

export default function MarkAsCompleteButton({ isComplete, toggleComplete }) {
  const { language } = useAppContext();
  return (
    <button
      onClick={toggleComplete}
      className={`px-4 py-2 rounded-3xl flex items-center justify-between w-fit focus:outline-none transition-colors duration-300 ${
        isComplete ? "bg-green-700 text-white" : "bg-pink-200 text-green-700 hover:bg-green-700/90 hover:text-white"
      }`}
    >
      <span className="flex items-center">
        {isComplete ? (
          <svg
            className="w-5 h-5 mr-2 text-white"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M16.707 5.293a1 1 0 00-1.414 0L8 12.586 4.707 9.293a1 1 0 00-1.414 1.414l4 4a1 1 0 001.414 0l8-8a1 1 0 000-1.414z"
              clipRule="evenodd"
            />
          </svg>
        ) : (
          <svg
            className="w-5 h-5 mr-2 text-green-700"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M9 18a1 1 0 01-.707-.293l-7-7a1 1 0 111.414-1.414L9 15.586l6.293-6.293a1 1 0 111.414 1.414l-7 7A1 1 0 019 18z"
              clipRule="evenodd"
            />
          </svg>
        )}
        {isComplete ? ButtonsTrans[language].complete : ButtonsTrans[language].markAsComplete}
      </span>
    </button>
  );
}
